import axios from "axios";
import idx from "idx";

import { SISR_TOKEN } from "../utils/access/constants";

const WS_SERVER_RESPONSE_CODE = {
  KO: "KO",
  OK: "OK",
};

export const makeRequest = async (
  method,
  url,
  auth,
  body,
  acceptLanguage = "it"
) => {
  //Prendo il token che mi serve per l'autenticazione dell'utente
  const authToken = auth ? { AUTHTOKEN: localStorage.getItem(SISR_TOKEN) } : {};
  const data = body ? { data: JSON.stringify(body) } : {};

  return await axios({
    method,
    url,
    headers: {
      "Content-Type": "application/json",
      "accept-language": acceptLanguage,
      ...authToken,
    },
    ...data,
  })
    .then((response) => {
      if (
        response.data.wsResult.status === WS_SERVER_RESPONSE_CODE.KO ||
        response.data.wsResult.result === WS_SERVER_RESPONSE_CODE.KO
      )
        throw new Error(response.data.wsResult.error.code);
      return response.data.data;
    })
    .then((data) => {
      return {
        data: idx(data, (_) => _.content) ? data.content : data,
        result: WS_SERVER_RESPONSE_CODE.OK,
        ...(idx(data, (_) => _.totalElements)
          ? { total: data.totalElements }
          : {}),
      };
    })
    .catch((err) => {
      if (err.response && err.response.status) {
        switch (err.response.status) {
          case 403:
            localStorage.removeItem(SISR_TOKEN);
            location.reload();
            return;
        }
      }

      //Controllo errori sul login
      if (err.response && err.response.data.wsResult.error.code) {
        return {
          result: WS_SERVER_RESPONSE_CODE.KO,
          code: err.response.data.wsResult.error.code,
        };
      }

      switch (err.message) {
        case "OPERATION_NOT_ALLOWED":
          return {
            result: WS_SERVER_RESPONSE_CODE.KO,
            code: "OPERATION_NOT_ALLOWED",
          };
        default:
          return {
            error: err.message,
            result: WS_SERVER_RESPONSE_CODE.KO,
            code: "GENERIC_ERROR",
          };
      }
    });
};
